import { render, staticRenderFns } from "./setTrain.vue?vue&type=template&id=3a30ebef&scoped=true&"
import script from "./setTrain.vue?vue&type=script&lang=js&"
export * from "./setTrain.vue?vue&type=script&lang=js&"
import style0 from "./setTrain.vue?vue&type=style&index=0&id=3a30ebef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30ebef",
  null
  
)

export default component.exports